<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <div class="projects-autocomplete relative bg-white p-4 shadow-md rounded-sm">
    <input
      v-model="searchQuery"
      type="text"
      placeholder="Zoek een adres"
      class="w-full relative focus-visible:shadow-none text-sm lg:text-base"
      @input="filterSuggestions"
      @focus="showSuggestions = true"
      @blur="hideSuggestions"
    >
    <img
      v-if="!searchQuery"
      src="@/assets/svg/map/icon-search.svg"
      alt=""
      class="search-icon absolute w-4 h-4 "
    >
    <button
      v-else
      class="absolute w-3 h-3 close-icon"
      @keyup.enter="resetSearch"
      @click.prevent="resetSearch"
    >
      <Close class="close-icon w-3 h-3" />
    </button>
    <ul
      v-if="filteredSuggestions.length"
      class="suggestions absolute top-full left-0 z-10 bg-white border border-gray-100 w-full max-h-[150px] m-0 p-0 list-none overflow-y-auto"
    >
      <li
        v-for="(suggestion, index) in filteredSuggestions"
        :key="index"
        class="px-2 py-1 hover:bg-gray-50 text-sm lg:text-base"
        @click="selectSuggestion(suggestion)"
      >
        {{ suggestion.address }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  components: {
    Close: () => import(/* webpackChunkName: "main"*/ '@/components/svg/Close.vue'),
  },
  props: {
    locations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchQuery: '',
      filteredSuggestions: [],
      showSuggestions: false
    };
  },
  methods: {
    filterSuggestions() {
      // Filter suggestions based on input matching address or name
      if (this.searchQuery) {
        this.filteredSuggestions = this.locations.filter(location =>
          location.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          location.address.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
        this.showSuggestions = true;
      } else {
        this.filteredSuggestions = [];
        this.showSuggestions = false;
      }
    },
    selectSuggestion(suggestion) {
      // Set the input value to the selected suggestion's name or city
      this.searchQuery = suggestion.name;
      this.showSuggestions = false;

      this.$emit('zoom-to-location', suggestion);
    },
    hideSuggestions() {
      // Hide suggestions with a slight delay to allow click event to register
      setTimeout(() => {
        this.showSuggestions = false;
      }, 200);
    },
    resetSearch() {
      this.searchQuery = '';
      this.filteredSuggestions = [];
      this.$emit('reset-map');
    }
  }
};
</script>

<style>
  .projects-autocomplete {
    .search-icon {
      top: 23px;
      right: 14px;
    }

    .close-icon {
      top: 23px;
      right: 14px;

      svg {
        @apply w-full h-full;
      }
    }
  }
</style>
